import Config from '@config';
import {
  FiltersGrid,
  Pagination,
  infiniteQueryOptions,
  normalizeInfiniteQueryData,
} from '@gasbi/shared/index';
import { createApi } from '@reduxjs/toolkit/query/react';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

import { ContractAddendumListItemReadModel } from './types';

export const contractAddendaApi = createApi({
  reducerPath: 'contractAddendaApi',
  baseQuery: axiosBaseQuery({ baseUrl: Config.VITE_API_URL }),
  tagTypes: ['ContractAddenda'],
  endpoints: builder => ({
    getContractAddendaI: builder.infiniteQuery<
      ContractAddendumListItemReadModel[],
      { contractId: string } & FiltersGrid,
      Pagination
    >({
      infiniteQueryOptions,
      query: ({ queryArg: { contractId, ...filters }, pageParam }) => ({
        url: `/contracts/${contractId}/addenda`,
        method: 'GET',
        params: { ...pageParam, ...filters },
      }),
      providesTags: (_, __, { contractId }) => [
        { type: 'ContractAddenda', id: contractId },
      ],
    }),
  }),
});

export const useGetContractAddendaInfiniteQuery =
  normalizeInfiniteQueryData<ContractAddendumListItemReadModel>(
    contractAddendaApi.useGetContractAddendaIInfiniteQuery,
  );
